<template>
    <div class="d-flex all-after-header-box">
        <!-- Левое меню модуля -->
        <div 
            :class="{'drawer-left-wrap dlw-dark-theme' : true, 'dlw-large' : (!drawerLeftMenuMini), 'drawer-menu-hover': drawerLeftMenuHover }"
            @mouseenter="LeftMenuMouseenter()"
            @mouseleave="LeftMenuMouseleave()"
        >
            <v-navigation-drawer
                absolute
                permanent
                class="drawer-menu"
                v-model="drawerLeftMenu"
            >

                <template 
                    v-if="$validatePermission({ permissions: ['EDMSConfiguration'] })"
                >
                    <v-list
                        nav
                        dense
                        class="dm-actions-list"
                    >
                        <v-list-item-group
                            color="#009c95"
                        >
                            <v-list-item 
                                link
                                class="v-item--active v-list-item--active drawer-menu-list-bigbtn"
                                @click="onCreateClicked"
                            >
                                <v-list-item-icon>
                                    <v-icon>mdi-plus-box</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Добавить") }}</v-list-item-title>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>

                    <v-divider></v-divider>
                </template>

                <v-list
                    nav dense shaped>
                    <v-list-item
                        link
                        key="Profile"
                        :to="{ name: 'Profile' }"
                    >

                        <v-list-item-icon>
                            <v-icon>far fa-user</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("Профиль") }}</v-list-item-title>                       
                    </v-list-item>
                </v-list>
                
                <template v-if="$validatePermission({ permissions: ['EDMSConfiguration'] })">
                    <!--header-->
                    <v-list class="dm-list-header" nav dense shaped>   
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ $t("Документы")}}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>

                    <v-list nav dense shaped>
                        <v-list-group 
                            v-model="groupMenu1.active"
                            :accordion="true"
                            @input="closeOtherGroups('groupMenu1')"
                            class="v-list-group-no-slamming"
                        >
                            
                            <template v-slot:prependIcon>
                                <v-icon>far fa-wrench</v-icon>
                            </template>
                            <template v-slot:activator>
                                <v-list-item-title>
                                    {{ $t("Шаблоны_внутренних_документов") }}
                                </v-list-item-title>
                            </template>
                            <template v-slot:appendIcon>
                                <v-icon>fas fa-chevron-down</v-icon>
                            </template>

                            <!-- Реквизиты -->
                            <v-list-item
                                link
                                key="Requisites"
                                :to="{ name: 'Requisites' }"
                            >

                                <v-list-item-icon>
                                    <v-icon></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Реквизиты") }}</v-list-item-title>
                            </v-list-item>

                            <!-- Группы_реквизитов -->
                            <!-- <v-list-item
                                link
                                key="RequisitesGroup"
                                :to="{ name: 'RequisitesGroup' }"
                            >

                                <v-list-item-icon>
                                    <v-icon></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Группы_реквизитов") }}</v-list-item-title>
                            </v-list-item> -->

                            <!-- Шаблоны -->
                            <v-list-item
                                link
                                key="Templates"
                                :to="{ name: 'Templates' }"
                            >

                                <v-list-item-icon>
                                    <v-icon></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Шаблоны") }}</v-list-item-title>
                            </v-list-item>

                        </v-list-group>
                    </v-list>

                    <v-list nav dense shaped>
                        <v-list-group 
                            v-model="groupMenu2.active"
                            :accordion="true"
                            @input="closeOtherGroups('groupMenu2')"
                            class="v-list-group-no-slamming"
                        >
                            <template v-slot:prependIcon>
                                <v-icon>far fa-wrench</v-icon>
                            </template>
                            <template v-slot:activator>
                                <v-list-item-title>
                                    {{ $t("Бизнес-процессы") }}
                                </v-list-item-title>
                            </template>
                            <template v-slot:appendIcon>
                                <v-icon>fas fa-chevron-down</v-icon>
                            </template>
                            
                            <!-- Реквизиты -->
                            <v-list-item
                                link
                                key="Workflows"
                                :to="{ name: 'Workflows' }"
                            >

                                <v-list-item-icon>
                                    <v-icon></v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>{{ $t("Схемы") }}</v-list-item-title>
                            </v-list-item>

                        </v-list-group>
                    </v-list>

                </template>

            </v-navigation-drawer>

        </div>

        <div class="content-box">
            <router-view />
        </div>
        
        <CreateDialog ref="CreateDlg" />

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import CreateDialog from '@/views/global/configuration/dialogs/CreateConfigurationObjectDlg.vue';

export default {
    name: 'ConfigurationMain',
    components: {
        CreateDialog
    },
    data: () => ({
        drawerLeftMenu: true,
        drawerLeftMenuHover: false,
        groupMenu1: {
            active: true
        },
        groupMenu2: {
            active: false
        }
    }),
    computed: {
        ...mapGetters({ drawerLeftMenuMini: 'isDrawerLeftMenuMinimized' }),
        drawerLeftMenuMini: {
            get: function() {
                return this.$store.getters['isDrawerLeftMenuMinimized'];
            },
            set: function(value) {
                this.$store.commit('SET_DRAWER_LEFT_MENU_MINIMIZED', value);
            }
        },
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        LeftMenuMouseenter() {
            if (this.drawerLeftMenuMini)
                this.drawerLeftMenuHover = true;
        },
        LeftMenuMouseleave() {
            this.drawerLeftMenuHover = false;
        },
        closeOtherGroups(groupName) {
            for (let group of Object.entries(this['_data']).filter(x => x[0].includes('groupMenu'))) {
                if (group[0] != groupName) {
                    group[1].active = false;
                }
            }
        },
        anyTimeOpenMenuPanel(){
            this.drawerLeftMenuMini = false;
        },
        async onCreateClicked() {
            let { params } = await this.$refs.CreateDlg.open();

            if (!params) return;

            switch (params.createType) {
                case 'Template':
                    await this.$router.push({ name: 'TemplateCard', query: { id: 'new', common: params.isCommon }, params: { id: 'new', common: params.isCommon }});
                    break;

                case 'Workflow':
                    await this.$router.push({ name: 'WorkflowCard', query: { id: 'new', common: params.isCommon }, params: { id: 'new', common: params.isCommon }});
                    break;

                default:
                    break;
            }
        },
    },
    created() {
        this.anyTimeOpenMenuPanel();
    }
}
</script>